import { Price as TilePrice } from '../src/Price';
export { TilePrice };
export default TilePrice;
